import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useSEO from "../hooks/useSEO";
import { SCROLL } from "../data/content";
import Hero from "../components/home/Hero";
import Marquee from "../components/Marquee";
import About from "../components/home/About";
import WaysToTravel from "../components/home/WaysToTravel";
import CompareTable from "../components/home/CompareTable";
import Destinations from "../components/home/Destinations";
import Activities from "../components/home/Activities";
import HowItWorks from "../components/home/HowItWorks";
import TeaserBand from "../components/home/TeaserBand";
import Contact from "../components/home/Contact";

export default function Home() {
    useSEO({
        title: "Journeys Unscripted | Private Tours from India · Bespoke Travel & Guided Group Tours",
        description:
            "Journeys Unscripted designs private tours from India around how you like to travel — bespoke travel itineraries, guided group tours and the HIT but HINT philosophy of private guiding. Travel Your Way · Experience Like a Local.",
    });

    const location = useLocation();
    useEffect(() => {
        const target = location.state?.scrollTo;
        if (target) {
            const t = setTimeout(() => SCROLL.go(target), 120);
            return () => clearTimeout(t);
        }
    }, [location.state]);

    return (
        <main>
            <Hero />
            <Marquee />
            <About />
            <WaysToTravel />
            <CompareTable />
            <Destinations />
            <Activities />
            <HowItWorks />
            <TeaserBand />
            <Contact />
        </main>
    );
}
